export default __webpack_public_path__ + "static/media/city_img_melbourne.55090a3a.png";